<script lang="ts">
    import { href, NoBookmarksFound } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import {bookmarkId,bookmarkItem,gridClass} from "../../../store"
    import Link from "svelte-link";
    import { Col, Image, Row } from "sveltestrap";
    import BookmarkDesciptionData from "./BookmarkDesciptionData.svelte";
    import BookmarkGrid from "./BookmarkGrid.svelte";
    let imgPath:string = "/assets/images/lightgallry"
    export let header:string
    export let id:string
    let setBookmarkId:string
    let setBookmarkItem:any
    let setGridClass:boolean
    bookmarkId.subscribe((value)=>{
        setBookmarkId = value
    })
    bookmarkItem.subscribe((value)=>{
        setBookmarkItem = value
    })
    const handleRemove = (getItem:any) => {
      getItem.fillstar = false
      bookmarkItem.update(value => value = setBookmarkItem.filter((data:any)=> data.id !== getItem.id))
    }
    gridClass.subscribe((value)=>{
      setGridClass = value
    })
</script>
<div class="tab-pane {setBookmarkId === id ? "active" : ""}" id={id}>
    <Card cardProps="mb-0" cardHeaderprops="d-flex">
      <div slot="customheader" class="d-flex align-items-center justify-content-between w-100">
        <BookmarkGrid header={header}/>
      </div>
      <div slot="contentbody">
        <div class="details-bookmark text-center {setGridClass ? "list-bookmark" : ""}">
          <Row>
            {#if header === "Favourites"}
              {#if setBookmarkItem.length == 0}
                <span>{NoBookmarksFound}</span>
              {:else}
                {#each setBookmarkItem as bookmarkItem}
                  <Col xl="3" md="4" class="xl-50">
                      <div class="card card-with-border bookmark-card o-hidden">
                          <div class="details-website">
                              <Image fluid src="{imgPath}/{bookmarkItem.img}" />
                              <div class="favourite-icon {bookmarkItem.class2} {bookmarkItem.fillstar ? "favourite" : ""}" >
                                  <Link href={href} on:click={()=>handleRemove(bookmarkItem)}>
                                      <i class="fa fa-star"></i>
                                  </Link>
                              </div>
                              <BookmarkDesciptionData bookmarkItem={bookmarkItem}/>
                          </div>
                      </div>
                  </Col>
                {/each}
              {/if}
              {:else}
                <span>{NoBookmarksFound}</span>
            {/if}
          </Row>
        </div>
      </div>
    </Card>
</div>